<template>
	<!-- 使用root-view -->
	<div class=" dashboard-root mt-0">dashboard</div>
</template>

<script>
	export default{
		name:"Dashboard",
		data: function () {
		    return {
		      count: 0
		    }
		},
		created:function(){
			console.log('dashboard created');
		}
	}
</script>

<style scoped>
	
	.dashboard-root{
		border:dashed 1px red;
	}
	
</style>
